import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { RelationUserFolderDb } from '../redux/relationUserFolderDbSlice';
import useCurrentUserId from './useCurrentUserId';

const useRUFsDb = () : [string[], RelationUserFolderDb[]] => {
  const relationUserFolders = useSelector((state: RootState) => state.relationUserFolderDb).relationUserFolders;
  const userId = useCurrentUserId();
  const ids = Object.keys(relationUserFolders).filter(id => relationUserFolders[id].userId === userId);
  ids.sort((a, b) => relationUserFolders[a].order - relationUserFolders[b].order);
  const values = ids.map(id => relationUserFolders[id]);

  return [ids, values];
}

export default useRUFsDb;
